export const ONE_LINK_PARAMS_MAP: Record<string, string> = {
  utm_promo: 'deep_link_sub2',
  pc: 'deep_link_sub3',
  utm_source: 'deep_link_sub4',
  utm_campaign: 'deep_link_sub5',
  utm_feature: 'deep_link_sub6',
  deep_link_value: 'deep_link_value',
};

export const getParam = (urlParams: URLSearchParams, key: string) => {
  return urlParams.get(key) || urlParams.get(ONE_LINK_PARAMS_MAP[key]) || null;
};

export const removeParam = (urlParams: URLSearchParams, key: string) => {
  urlParams.delete(key);
  urlParams.delete(ONE_LINK_PARAMS_MAP[key]);
};
